<template>
  <div class="myDownload">
    <div class="search">
      <div class="radio-group">
        <div v-for="item in menus" :key="item.id" class="custom-radio-card" :class="{ 'custom-radio-card-checked': templateType === item.id }" @click="changeTemplateType(item.id)">
          <div class="custom-radio-card-title">{{ item.name }}</div>
        </div>
      </div>
      <a-input-search
        v-model="keyword"
        class="search-input"
        enter-button
        :placeholder="$t('project.inputSearchKeywords')"
        style="width: 300px"
      />
    </div>
    <div class="filter">
      <div class="filterLeft">
        <a-select
          v-model="comprehensiveValue"
          allowClear
          class="filterSelect"
          placeholder="综合"
          style="width: 150px"
        >
          <a-select-option v-for="(item, index) in comprehensiveOptions" :value="item.value" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
        <a-select
          v-model="industryValue"
          allowClear
          class="filterSelect"
          placeholder="行业"
          style="width: 150px"
        >
          <a-select-option v-for="(item, index) in industryOptions" :key="index" :value="item.value">
            {{ item.name }}
          </a-select-option>
        </a-select>
        <a-range-picker
          class="filterSelect"
          format="YYYY-MM-DD"
          style="width: 270px; height: 32px"
          @change="onChange"
          @select="onSelect"
        />
      </div>
      <div class="filterRight">
        <div class="iconBox">
          <a-icon type="reload" class="icon" style="font-size: 20px" @click="refreshList()" />
          <a-icon type="appstore" class="icon" style="font-size: 20px" @click="changeList()" />
        </div>
      </div>
    </div>
    <div class="listTable project-kind-list">
      <CardList
        v-if="changeListFlag"
        :data-list="dataList"
        :pageTotal="pageTotal"
        :loadDataFunc="mockList"
        :del-handle="delHandle"
        :preview-handle="previewHandle"
        :use-handle="useHandle"
        cardType="download"
        class="cardList"
      />
      <div v-else class="listTable">
        <a-table
          :selectedRowKeys="selectedKeys"
          :bordered="false"
          :columns="columns"
          :dataSource="dataList"
          :pagination="pagination"
          :rowSelection="rowSelection"
          :rowKey="record => record.id"
        >
          <template slot="action" slot-scope="text, record">
            <a class="button-link" @click="previewHandle(record)">{{ $t('project.preview') }}</a>
            <a class="button-link" @click="useHandle(record)">{{ $t('project.use') }}</a>
            <a class="button-link" @click="delHandle(record)">{{ $t('project.delete') }}</a>
          </template>
          <template slot="coverUrl" slot-scope="text, record">
            <img :src="imgHost + record.coverUrl" alt="img" class="hover-mask" />
          </template>
        </a-table>
      </div>
    </div>

    <a-modal
      :visible="delVisible"
      :title="$t('project.deleteTemplate')"
      @cancel="handleCancel"
      @ok="delHandleOk"
    >
      <div>
        <a-icon type="exclamation-circle" style="color: orange" />
        {{ $t('project.moveToRecycleBin') }}
      </div>
    </a-modal>

    <a-modal
      :visible="previewVisible"
      :footer="null"
      :title="$t('project.previewTemplate')"
      @cancel="handlePreviewCancel"
      :width="1550"
    >
      <PreviewTemplate v-if="previewVisible" :previewData="previewData" type='download'/>
    </a-modal>
    <!--使用等于创建沙盘-->
    <create-sand-modal :createSandVisible.sync="createSandVisible" :templateInfo="templateInfo"></create-sand-modal>
    <!-- <a-modal
      :visible="createProjectModelVisible"
      title="基础信息"
      :width="602"
      @beforeOk="handleBeforeOk"
      @cancel="handleProjectCancel"
    >
      <a-form :model="form">
        <a-form-item
          :help="form.projectName.help"
          :label="form.projectName.label"
          :required="form.projectName.required"
          :validateStatus="form.projectName.status"
          field="projectName"
        >
          <a-input v-model="form.projectName.value" />
        </a-form-item>

        <a-form-item
          :help="form.coverPath.help"
          :label="form.coverPath.label"
          :required="form.coverPath.required"
          :validateStatus="form.coverPath.status"
          field="coverPath"
        >
          <a-upload
            :showUploadList="false"
            accept="image/png, image/jpeg"
            :action="baseURL"
            @change="onChangeFile"
            :beforeUpload="beforeUpload"
            :headers="{ Authorization: token }"
          >
            <div
              :class="`ant-upload-list-item${
                form.coverPath.value && form.coverPath.value.status === 'error'
                  ? ' ant-upload-list-item-error'
                  : ''
              }`"
            >
              <div
                v-if="form.coverPath.value && form.coverPath.value"
                class="ant-upload-list-picture custom-upload-avatar"
              >
                <img :src="form.coverPath.value" />
                <div class="ant-upload-list-picture-mask">
                  <a-icon type="edit" />
                </div>
              </div>
              <div v-else class="ant-upload-picture-card">
                <div class="ant-upload-picture-card-text">
                  <a-icon type="plus" />
                </div>
              </div>
            </div>
          </a-upload>
        </a-form-item>

        <a-form-item
          :help="form.projectLocation.help"
          :label="form.projectLocation.label"
          :required="form.projectLocation.required"
          :validateStatus="form.projectLocation.status"
          field="projectLocation"
        >
          <LocationSelect @update-value="changeLocation" @update-status="updateStatus" />
        </a-form-item>

        <a-form-item
          :help="form.coordinate.help"
          :label="form.coordinate.label"
          :required="form.coordinate.required"
          :validateStatus="form.coordinate.status"
          field="coordinate"
        >
          <a-row :gutter="16">
            <a-col :span="18">
              <a-select v-model="form.coordinate.value" style="width: 100%">
                <a-select-option
                  v-for="item in form.coordinate.coordinateList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="6">
              <a-row type="flex" justify="end">
                <a-button>
                  自定义导入
                  <a-tooltip title="点击查看帮助说明">
                    <a-icon type="info-circle" style="margin-left: 9px; color: #0166fc" @click="toWebSite" />
                  </a-tooltip>
                </a-button>
              </a-row>
            </a-col>
          </a-row>
        </a-form-item>

        <a-form-item
          :help="form.desc.help"
          :label="form.desc.label"
          :required="form.desc.required"
          :validateStatus="form.desc.status"
          field="desc"
        >
          <a-textarea
            v-model="form.desc.value"
            :autoSize="{ minRows: 4, maxRows: 6 }"
            allowClear
            placeholder="请输入项目描述"
          />
        </a-form-item>
      </a-form>
    </a-modal> -->
  </div>
</template>

<script>
import { v4 } from 'uuid'
import { getDownLoadPage, getCoordinate, addProjectApi, addRecycleBin } from '@/api/myTemplate'
import CardList from './templateCard.vue'
import PreviewTemplate from './previewTemplate.vue'
// import LocationSelect from './components/locationSelect/index.vue'
import CreateSandModal from '@/views/workbench/workbench/MyProject/components/CreateSandModal.vue'
import { Modal } from 'ant-design-vue'

export default {
  name: 'MyDownload',
  components: {
    CardList,
    PreviewTemplate,
    CreateSandModal,
    CreateSandModal,
    // LocationSelect
  },
  data() {
    return {
      templateType: '1',
      keyword: '',
      timeRange: [],
      previewData: {},
      menus: [
        { id: '1', name: '项目方案' },
        { id: '2', name: '工艺模拟' }
      ],
      comprehensiveValue: undefined,
      comprehensiveOptions: [
        { id: 'publishTime', name: '最新发布' },
        { id: 'collectCnt', name: '热门推荐' },
        { id: 'downloadCnt', name: '最多使用' },
        { id: 'browseCnt', name: '最多浏览' }
      ],
      imgHost: process.env.VUE_APP_CTYUN_URL,
      baseURL: process.env.RENDERER_VITE_API_WORKBENCH_URL + '/api/micro/file/zos/upload',
      token: localStorage.getItem('_xh-token'),
      statusValue: undefined,
      statusOptions: [
        {id:'0',name:'project.uploadSuccess'},
        {id:'1',name:'project.pendingReview'},
        {id:'2',name:'project.sold'},
        {id:'3',name:'project.reviewNotPassed'},
        {id:'-1',name:'project.soldOff'},
        {id:'-2',name:'project.unknownStatus'}
      ],
      columns:[
        {
          title: '序号',
          dataIndex: 'index'
        },
        {
          title: '模版名称',
          dataIndex: 'name'
        },
        {
          title: '预览图',
          scopedSlots: { customRender: 'coverUrl' },
          width: 300,
          align: 'center',
        },
        {
          title: '版本',
          dataIndex: 'version'
        },
        {
          title: '行业',
          dataIndex: 'industryValue'
        },
        {
          title: '上传时间',
          dataIndex: 'publishTime',
          width: 300,
          align: 'center',
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          width: 200,
          align: 'center',
        }
      ],
      industryValue: undefined,
      industryOptions: [],
      dataList: [],
      selectedKeys: [],
      delTemplate: {},
      changeListFlag: true,
      pagination: { pageSize: 5 },
      delVisible: false,
      previewVisible: false,
      createProjectModelVisible: false,
      form: {
        projectName: {
          label: '项目名称',
          required: true,
          value: '',
          help: '',
          status: undefined
        },
        coverPath: {
          label: '项目封面',
          required: false,
          value: '',
          help: '',
          status: undefined
        },
        cover: {
          label: '项目封面',
          required: false,
          value: '',
          help: '',
          status: undefined
        },
        projectLocation: {
          label: '项目位置',
          required: true,
          value: {
            lon: '',
            lat: ''
          },
          help: '',
          status: undefined
        },
        coordinate: {
          label: '坐标系',
          required: false,
          value: '',
          coordinateList: [
            {
              label: '默认',
              value: ''
            },
            {
              label: 'EPSG:3857 WGS 84/Pseudo-Mercator',
              value: '1'
            },
            {
              label: 'EPSG:3857 -Zone 25',
              value: '2'
            },
            {
              label: 'EPSG:3857 -Zone 26',
              value: '3'
            },
            {
              label: 'EPSG:3857 -Zone 27',
              value: '4'
            }
          ],
          help: '',
          status: undefined
        },
        desc: {
          label: '项目描述',
          required: true,
          value: '',
          help: '',
          status: undefined
        },
      },
      pageTotal: 0,
      createSandVisible: false,
      templateInfo:{}
    }
  },
  computed: {
    rowSelection() {
      return {
        type: 'checkbox',
        showCheckedAll: true,
        onlyCurrent: false
      }
    },
    userId() {
      return JSON.parse(localStorage.getItem('userInfo'))?.userId || null
    }
  },
  watch: {
    templateType: {
      handler(newValue) {
        console.log(newValue, 'templateType')
        this.mockList()
      }
    },
    industryValue: {
      handler(newValue) {
        console.log(newValue, 'industryValue')
        this.mockList()
      }
    },
    statusValue: {
      handler(newValue) {
        console.log(newValue, 'industryValue')
        this.mockList()
      }
    }
  },
  created() {
    this.industryOptions = JSON.parse(localStorage.getItem('getIndustryList') || '[]')
    this.getCoordinate()
    this.mockList()
  },
  methods: {
    getCoordinate() {
      getCoordinate().then((res) => {
        if (res.code === 200) {
          this.form.coordinate.coordinateList = res.data
          this.form.coordinate.value = 37
        }
      })
    },
    mockList(pageNo = 1, pageSize = 10) {
      const params = {
        keyword: this.keyword,
        itemStatus: this.statusValue,
        type: this.templateType,
        industry: this.industryValue,
        startPublishDate: this.timeRange.length ? this.timeRange[0] : '',
        endPublishDate: this.timeRange.length ? this.timeRange[1] : '',
        tempalteIds: [],
        sourceIds: [],
        valid: null,
        pageNo,
        pageSize,
        orderField: 'publishTime',
        orderType: 'desc'
      }
      getDownLoadPage(params).then(res => {
        if(res.status === 0) {
          this.dataList = res.data.data
          this.pageTotal = res.data.count
          this.dataList.forEach((item, index) => {
            item.index = index + 1
            item.itemStatus = Number(item.itemStatus) === 0 ? 'project.uploadSuccess' : 
                            Number(item.itemStatus) === 1 ? 'project.pendingReview' : 
                            Number(item.itemStatus) === 2 ? 'project.sold' : 
                            Number(item.itemStatus) === 3 ? 'project.reviewNotPassed' : 
                            Number(item.itemStatus) === -1 ? 'project.soldOff' : 'project.unknownStatus'
            item.industryValue = this.industryOptions.find((industry) => industry.value === item.industry)?.name
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
    onSelect(dateString, date) {
      console.log('onSelect', dateString, date)
    },
    onChange(dateString, date) {
      this.timeRange = dateString || []
      this.mockList()
    },
    refreshList() {
      this.mockList()
    },
    changeList() {
      this.changeListFlag = !this.changeListFlag
    },
    delHandle(item) {
      console.log('删除模版', item)
      this.delVisible = true
      this.delTemplate = item
      this.mockList()
    },
    useHandle(item) {
      this.createSandVisible = true
      this.templateInfo = item
      // this.createProjectModelVisible = true
      // console.log('使用模版', item)
      // this.form.projectName.value = item.name
      // this.form.desc.value = item.remark
      // this.form.coverPath.value = this.imgHost + item.coverUrl
    },
    onChangeFile(currentFile) {
      if (currentFile[currentFile.length-1].status === 'done') {
        this.form.cover.value = {
          ...currentFile[currentFile.length-1]
        }
        this.form.coverPath.value = currentFile[currentFile.length-1].response.data.fileFullPath
      }
    },
    previewHandle(item) {
      this.previewData = item
      this.previewVisible = true
    },
    delHandleOk() {
      this.delVisible = false
      const params = {
        sourceId: this.delTemplate.id
      }
      addRecycleBin(params).then(res => {
        if (res.status === 0) {
          Modal.success({
            title: '删除成功',
            content: ''
          })
          this.mockList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleCancel() {
      this.delVisible = false
    },
    handlePreviewCancel(){
      this.previewVisible = false
    },
    handleBeforeOk(done) {
      let verificationdSuccess = true
      for (const key in this.form) {
        const isRequired = this.form[key].required
        const valueType = typeof this.form[key].value
        if (isRequired) {
          if (valueType === 'string') {
            if (this.form[key].value === '') {
              this.form[key].help = '该项为必填项'
              this.form[key].status = 'error'
              verificationdSuccess = false
            }
          } else {
            if (!this.form[key].value.lat || !this.form[key].value.lon) {
              this.form[key].help = '必须输入经纬度'
              this.form[key].status = 'error'
              verificationdSuccess = false
            }
          }
        }
        if (this.form[key].status === 'error') {
          verificationdSuccess = false
        }
      }
      if (!verificationdSuccess) return done(false)

      const addParams = {
          account: this.userId,
          projectId: v4(),
          projectName: this.form.projectName.value,
          coverPath: this.form.coverPath.value,
          nation: this.form.projectLocation.value.nation,
          province: this.form.projectLocation.value.province,
          city: this.form.projectLocation.value.city,
          address: this.form.projectLocation.value.address,
          longitude: this.form.projectLocation.value.lon,
          latitude: this.form.projectLocation.value.lat,
          coordinateType: this.form.coordinate.value,
          coordinateCode: this.form.coordinate.value,
          coordinateContent: this.form.coordinate.value,
          description: this.form.desc.value
        }
        addProjectApi(addParams).then((response) => {
          if (response.code !== 200) {
            this.$message.error(response.message)
          } else {
            done()
            this.$message.success('新建成功')
          }
        })
    },
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
          reject(false)
          this.$message.error('只能上传 PNG 或 JPG 格式的图片')
        }
        if (file.size > 1024 * 1024 * 5) {
          reject(false)
          this.$message.error('图片大小不能超过 5M')
        }
        resolve(true)
      })
    },
    changeLocation(value) {
      this.form.projectLocation.value = value
    },
    updateStatus(value) {
      this.form.projectLocation = {
        ...this.form.projectLocation,
        ...value
      }
    },
    toWebSite() {
      window._xh.useMain.openExternalUrl(process.env.RENDERER_VITE_APP_HELP_HOST)
    },
    changeTemplateType(id) {
      this.templateType = id
    },
    handleProjectCancel(){
      this.createProjectModelVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.myDownload {
  display: flex;
  flex-direction: column;
  //padding:0  16px;
  .search,
  .filter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    .radio-group {
      display: flex;
      align-items: center;
      gap: 20px;
    }
    .search-input {
      width: 300px;
    }
  }

  .filter {
    //height: 5%;
    //background-color: rgba(62, 86, 93, 0.3);
    .filterLeft,
    .filterRight {
      //width: 48%;
      //height: 100%;
      display: flex;
    }

    .filterLeft {
      display: flex;
      justify-content: space-between;
      align-items: center;
      //background: #00081c;
      padding: 5px;
      // width: 40%;

      .filterSelect {
        width: 120px;
        margin: 0 10px;
        &:first-of-type {
          margin-left: 0;
        }
      }
    }

    .filterRight {
      width: 25%;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .iconBox {
        background: #00081c;
        padding: 5px;
      }

      .icon {
        margin: 0 5px;
        border: 1px solid #2b3347;
        cursor: pointer;
      }
    }
  }

  .listTable {
    margin-top: 10px;

    .cardList {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin: 10px 0;
      //overflow: auto;
    }
    .button-link{
      margin-left: 15px;
      &::first-of-type{
        margin-left: 0;
      }
    }
    .hover-mask{
      width: auto;
      height: 36px;
      object-fit: cover;
      aspect-ratio: 4 / 3;
    }

    /* &-list {
       .more-card {
         width: 100%;
         margin-right: 10px;
         margin-left: 40px;
         background: var(--primary-bg-color);
         border: 1px solid var(--lv1-border-color);
         border-radius: 2px;
         cursor: pointer;
         display: flex;
         justify-content: center;
         align-items: center;

         .plus-icon {
           display: block;
           margin: 0 auto;
         }
       }
     }*/
  }
}
.custom-radio-card {
  background: #313132;
  width: 96px;
  height: 32px;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #C0C0C0;
  cursor: pointer;
}

.custom-radio-card-title {
  color: #fff;
  font-size: 14px;
}

.custom-radio-card-checked {
  background-color: #0166FC;
}

.custom-radio-card:hover .custom-radio-card-title,
.custom-radio-card-checked .custom-radio-card-title {
  color: #fff;
}
</style>
